module.exports = __webpack_public_path__ + "assets/img/yzzx_m_medinhealth.bd552c15.png";